import { default as _91slug_931pnRunys61Meta } from "/app/pages/b/[slug].vue?macro=true";
import { default as _91id_930dtRvYPE7GMeta } from "/app/pages/i/[id].vue?macro=true";
import { default as dla_45firm2kXBFa1RXiMeta } from "/app/pages/i/dla-firm.vue?macro=true";
import { default as dostawalc6wXwArUUMeta } from "/app/pages/i/dostawa.vue?macro=true";
import { default as jak_45to_45dzialaoXOzZohXR0Meta } from "/app/pages/i/jak-to-dziala.vue?macro=true";
import { default as metody_45platnosci0NRTpbRHwmMeta } from "/app/pages/i/metody-platnosci.vue?macro=true";
import { default as voucherp3DeJOWKHhMeta } from "/app/pages/i/voucher.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_93lPUjAvGXMQMeta } from "/app/pages/k/[id].vue?macro=true";
import { default as kalendarziONrMjlxqNMeta } from "/app/pages/kalendarz.vue?macro=true";
import { default as kontaktzJWjXi4cLvMeta } from "/app/pages/kontakt.vue?macro=true";
import { default as dostawa2iA6F7QT78Meta } from "/app/pages/koszyk/dostawa.vue?macro=true";
import { default as indexrSE0LpQDNJMeta } from "/app/pages/koszyk/index.vue?macro=true";
import { default as logowanieYR7D0lpn8KMeta } from "/app/pages/koszyk/logowanie.vue?macro=true";
import { default as platnoscZWBGXF2vUMMeta } from "/app/pages/koszyk/platnosc.vue?macro=true";
import { default as koszyk0Dj7bzE0VfMeta } from "/app/pages/koszyk.vue?macro=true";
import { default as _91token_9330PNsxHrQ3Meta } from "/app/pages/opinie/[token].vue?macro=true";
import { default as _91slug_93NVspau3cAjMeta } from "/app/pages/p/[slug].vue?macro=true";
import { default as _91id_93lsio9qHHVNMeta } from "/app/pages/podsumowanie/[id].vue?macro=true";
import { default as indexNEhbNriHuuMeta } from "/app/pages/podsumowanie/index.vue?macro=true";
import { default as podsumowanieQMHUl2v4KUMeta } from "/app/pages/podsumowanie.vue?macro=true";
import { default as rezerwacja3prEnxYjByMeta } from "/app/pages/rezerwacja.vue?macro=true";
import { default as system_45rezerwacyjnyvW0ppYDD35Meta } from "/app/pages/system-rezerwacyjny.vue?macro=true";
import { default as szukajZk5XqiArOPMeta } from "/app/pages/szukaj.vue?macro=true";
import { default as _91id_9380IpIZAgZEMeta } from "/app/pages/tor/[id].vue?macro=true";
import { default as logowaniefT8Lr5vafBMeta } from "/app/pages/u/logowanie.vue?macro=true";
import { default as _91id_93law7FdxMYuMeta } from "/app/pages/u/moje-konto/adresy/[id].vue?macro=true";
import { default as addsLbyn6e9FrMeta } from "/app/pages/u/moje-konto/adresy/add.vue?macro=true";
import { default as indexlEdsEdPrd8Meta } from "/app/pages/u/moje-konto/adresy/index.vue?macro=true";
import { default as adresyaOU6rysYkSMeta } from "/app/pages/u/moje-konto/adresy.vue?macro=true";
import { default as indexVQDG9yxLTyMeta } from "/app/pages/u/moje-konto/index.vue?macro=true";
import { default as profilydHRQ4V1lWMeta } from "/app/pages/u/moje-konto/profil.vue?macro=true";
import { default as moje_45kontonPsl2DyyOGMeta } from "/app/pages/u/moje-konto.vue?macro=true";
import { default as przypomnienie_45hasla9UIRJa2ouVMeta } from "/app/pages/u/przypomnienie-hasla.vue?macro=true";
import { default as rejestracjavsfh0gnw7nMeta } from "/app/pages/u/rejestracja.vue?macro=true";
import { default as _91id_93ckytl8ZP8QMeta } from "/app/pages/w/[id].vue?macro=true";
export default [
  {
    name: "b-slug",
    path: "/b/:slug()",
    component: () => import("/app/pages/b/[slug].vue")
  },
  {
    name: "i-id",
    path: "/i/:id()",
    component: () => import("/app/pages/i/[id].vue")
  },
  {
    name: "i-dla-firm",
    path: "/i/dla-firm",
    component: () => import("/app/pages/i/dla-firm.vue")
  },
  {
    name: "i-dostawa",
    path: "/i/dostawa",
    component: () => import("/app/pages/i/dostawa.vue")
  },
  {
    name: "i-jak-to-dziala",
    path: "/i/jak-to-dziala",
    component: () => import("/app/pages/i/jak-to-dziala.vue")
  },
  {
    name: "i-metody-platnosci",
    path: "/i/metody-platnosci",
    component: () => import("/app/pages/i/metody-platnosci.vue")
  },
  {
    name: "i-voucher",
    path: "/i/voucher",
    component: () => import("/app/pages/i/voucher.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "k-id",
    path: "/k/:id()",
    component: () => import("/app/pages/k/[id].vue")
  },
  {
    name: "kalendarz",
    path: "/kalendarz",
    component: () => import("/app/pages/kalendarz.vue")
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/app/pages/kontakt.vue")
  },
  {
    name: koszyk0Dj7bzE0VfMeta?.name,
    path: "/koszyk",
    meta: koszyk0Dj7bzE0VfMeta || {},
    component: () => import("/app/pages/koszyk.vue"),
    children: [
  {
    name: "koszyk-dostawa",
    path: "dostawa",
    component: () => import("/app/pages/koszyk/dostawa.vue")
  },
  {
    name: "koszyk",
    path: "",
    component: () => import("/app/pages/koszyk/index.vue")
  },
  {
    name: "koszyk-logowanie",
    path: "logowanie",
    component: () => import("/app/pages/koszyk/logowanie.vue")
  },
  {
    name: "koszyk-platnosc",
    path: "platnosc",
    component: () => import("/app/pages/koszyk/platnosc.vue")
  }
]
  },
  {
    name: "opinie-token",
    path: "/opinie/:token()",
    component: () => import("/app/pages/opinie/[token].vue")
  },
  {
    name: "p-slug",
    path: "/p/:slug()",
    component: () => import("/app/pages/p/[slug].vue")
  },
  {
    name: podsumowanieQMHUl2v4KUMeta?.name,
    path: "/podsumowanie",
    meta: podsumowanieQMHUl2v4KUMeta || {},
    component: () => import("/app/pages/podsumowanie.vue"),
    children: [
  {
    name: "podsumowanie-id",
    path: ":id()",
    meta: _91id_93lsio9qHHVNMeta || {},
    component: () => import("/app/pages/podsumowanie/[id].vue")
  },
  {
    name: "podsumowanie",
    path: "",
    meta: indexNEhbNriHuuMeta || {},
    component: () => import("/app/pages/podsumowanie/index.vue")
  }
]
  },
  {
    name: "rezerwacja",
    path: "/rezerwacja",
    component: () => import("/app/pages/rezerwacja.vue")
  },
  {
    name: "system-rezerwacyjny",
    path: "/system-rezerwacyjny",
    component: () => import("/app/pages/system-rezerwacyjny.vue")
  },
  {
    name: "szukaj",
    path: "/szukaj",
    component: () => import("/app/pages/szukaj.vue")
  },
  {
    name: "tor-id",
    path: "/tor/:id()",
    component: () => import("/app/pages/tor/[id].vue")
  },
  {
    name: "u-logowanie",
    path: "/u/logowanie",
    meta: logowaniefT8Lr5vafBMeta || {},
    component: () => import("/app/pages/u/logowanie.vue")
  },
  {
    name: moje_45kontonPsl2DyyOGMeta?.name,
    path: "/u/moje-konto",
    meta: moje_45kontonPsl2DyyOGMeta || {},
    component: () => import("/app/pages/u/moje-konto.vue"),
    children: [
  {
    name: adresyaOU6rysYkSMeta?.name,
    path: "adresy",
    component: () => import("/app/pages/u/moje-konto/adresy.vue"),
    children: [
  {
    name: "u-moje-konto-adresy-id",
    path: ":id()",
    component: () => import("/app/pages/u/moje-konto/adresy/[id].vue")
  },
  {
    name: "u-moje-konto-adresy-add",
    path: "add",
    component: () => import("/app/pages/u/moje-konto/adresy/add.vue")
  },
  {
    name: "u-moje-konto-adresy",
    path: "",
    component: () => import("/app/pages/u/moje-konto/adresy/index.vue")
  }
]
  },
  {
    name: "u-moje-konto",
    path: "",
    component: () => import("/app/pages/u/moje-konto/index.vue")
  },
  {
    name: "u-moje-konto-profil",
    path: "profil",
    component: () => import("/app/pages/u/moje-konto/profil.vue")
  }
]
  },
  {
    name: "u-przypomnienie-hasla",
    path: "/u/przypomnienie-hasla",
    meta: przypomnienie_45hasla9UIRJa2ouVMeta || {},
    component: () => import("/app/pages/u/przypomnienie-hasla.vue")
  },
  {
    name: "u-rejestracja",
    path: "/u/rejestracja",
    meta: rejestracjavsfh0gnw7nMeta || {},
    component: () => import("/app/pages/u/rejestracja.vue")
  },
  {
    name: "w-id",
    path: "/w/:id()",
    component: () => import("/app/pages/w/[id].vue")
  }
]